import React, {useState, useCallback, useEffect} from 'react';
import {compose} from 'recompose';
import styled from 'styled-components';
import {hot} from 'react-hot-loader';
import {Modal, Header, Icon, Button, Form, Message} from 'semantic-ui-react';

import {withLocale} from 'op/components/locale';
import {withReportRemarks} from '../../../../components/report/remark-modal/remark-modal.helper';



const FailedRemarkModal = ({locale, readOnly, value, kpiResult, onChange, clicked, isMandatoryRemarkForAllKPI}) => {
    const [openModal, setOpenModal] = useState(false);
    const [fieldValue, setFieldValue] = useState(value);
    const [showMsg, setShowMsg] = useState(false);

    const firstOpen = isMandatoryRemarkForAllKPI ? (value === null || value === undefined || value === '') : (value === null || value === undefined || value === '') && kpiResult === false;

    const onSave = () => {
        if (fieldValue) {
            onChange(fieldValue);
            setOpenModal(false);
            setShowMsg(false)
        } else {
            setOpenModal(true)
            setShowMsg(true)
        }
    };

    const onTextChange = (value)=>{
        setFieldValue(value);
        setShowMsg(false);
    }

    useEffect(() => {
        if (clicked) {
            if (isMandatoryRemarkForAllKPI) {
                setOpenModal(true)
            } else {
                kpiResult === false ? setOpenModal(true) : setOpenModal(false);
            }
        }
    }, [kpiResult]);

    return (
        <Modal
            trigger={
                <Icon style={{margin: 'auto 10px auto 0'}} name={!!(value || readOnly) ? 'info circle' : 'edit'}
                      onClick={() => setOpenModal(true)}/>
            }
            open={openModal}
            onClose={() => setOpenModal(false)}
            style={{direction: locale._meta.rtl ? 'rtl' : 'ltr'}}
            closeOnDimmerClick={!firstOpen}
        >
            <Header icon='edit' content={locale.title}/>
            <Modal.Content>
                <Form>
                    <Form.TextArea
                        lable={locale.title}
                        value={fieldValue}
                        readOnly={readOnly}
                        onChange={(e) => onTextChange(e.target.value)}
                    />
                    <Message color='red' hidden={!showMsg}>
                        You have to write some remarks
                    </Message>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                {!firstOpen && (
                    <Button onClick={() => setOpenModal(false)} floated='left'>
                        <Icon name='remove'/> {locale._system.close}
                    </Button>
                )}
                <Button disabled={readOnly} onClick={onSave} primary>
                    <Icon name='save'/> {locale._system.save}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default compose(
    hot(module),
    withReportRemarks,
    withLocale('report.remarks'),
)(FailedRemarkModal);

